import { render, staticRenderFns } from "./AddDependentVoluntary.vue?vue&type=template&id=10ce5e10&"
import script from "./AddDependentVoluntary.vue?vue&type=script&lang=js&"
export * from "./AddDependentVoluntary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports